import client from 'core/axios';
import handleError from 'core/axios/handleError';
import {
  handleJSONResponse,
  handleFileDownloadResponse,
} from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

// eslint-disable-next-line import/prefer-default-export
export const getPathResult = ({ pathResultId, version = 'v2' }) =>
  client
    .request({
      url: `${version}/swipe/path/${pathResultId}/result`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

// eslint-disable-next-line import/prefer-default-export
export const updatePathChoice = ({ assessmentId, payload, version = 'v2' }) =>
  client
    .request({
      url: `${version}/swipe/path/${assessmentId}/path-choices`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPathAssessmentList = ({ userId, version = 'v2' }) =>
  client
    .request({
      url: `${version}/swipe/assessments/path/${userId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const downloadBulkReports = ({ data, version = 'v2' }) =>
  client
    .request({
      url: `/${version}/swipe/bulk-reports/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSurveyDetails = ({ studentId, version = 'v2' }) => {
  let url = `/${version}/swipe/results/`;
  if (studentId) {
    url = `${url}/${studentId}/`;
  }
  return client
    .request({
      url,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
};

export const getFindYourPathAssessmentResults = ({ params, version = 'v2' }) =>
  client
    .request({
      url: `/${version}/swipe/find-your-path-assessments/`,
      params,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFindYourPathAssessmentResult = ({
  params,
  assessmentId,
  version = 'v2',
}) =>
  client
    .request({
      url: `/${version}/swipe/find-your-path-assessments/${assessmentId}/`,
      params,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAssessmentCSVReport = ({
  params = {},
  payload = {},
  version = 'v2',
}) =>
  client
    .request({
      url: `/${version}/swipe/csv-report/`,
      params,
      data: payload,
      method: RequestMethod.POST,
    })
    .then(handleFileDownloadResponse)
    .catch(handleError);

export const getAssessmentPDFReport = ({
  params = {},
  payload = {},
  version = 'v2',
}) =>
  client
    .request({
      url: `/${version}/swipe/csv-report/`,
      params,
      data: payload,
      method: RequestMethod.POST,
    })
    .then(handleJSONResponse)
    .catch(handleError);
